import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconWrapper, FILL_COLOR_CLASS_NAMES } from "./IconWrapper";
import classNames from "classnames";
const SortUpIcon = (props) => {
    const colorClassName = props.color
        ? FILL_COLOR_CLASS_NAMES[props.color]
        : null;
    return (_jsx(IconWrapper, Object.assign({}, props, { children: _jsxs("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsx("path", Object.assign({ d: "M10.902 29h18.197c1.69 0 2.536-2.048 1.343-3.24l-9.095-9.404a1.893 1.893 0 0 0-2.68 0l-9.109 9.406C8.366 26.95 9.21 29 10.902 29Z", fill: "currentColor" }, props, { className: classNames(colorClassName, props.className) })), _jsx("title", { children: props.title })] })) })));
};
export default SortUpIcon;
//# sourceMappingURL=SortUpIcon.js.map